import {
  DialogContent,
  DialogActions,
  Button,
  Stack,
  tokens,
} from '@cast/design-system';

import { AssignCredentialsDialogHeader } from '../../../_components/AssignCredentialsDialogHeader';
import { ErrorState, ErrorStateProps } from '../../../_components/ErrorState';

type ErrorSlideProps = ErrorStateProps & {
  onRetry: () => void;
  onClose: () => void;
};

export const ErrorSlide = ({
  title,
  testId,
  onRetry,
  onClose,
}: ErrorSlideProps) => {
  return (
    <Stack position="relative" data-testid={testId}>
      <AssignCredentialsDialogHeader dismiss={onClose} />
      <DialogContent>
        <ErrorState title={title} />
      </DialogContent>
      <DialogActions
        sx={{ py: 16, borderTop: tokens.theme.border.structural.neutralSubtle }}
      >
        <Button
          onClick={onClose}
          variant="secondary"
          testId="close-dialog-button"
        >
          Close
        </Button>
        <Button onClick={onRetry} testId="retry-button">
          Retry
        </Button>
      </DialogActions>
    </Stack>
  );
};
